/**
 * `New` aus `IwmViewContainer`/`IwmViewRechnungen`. `IwmViewBestellposition` zeigt dieselbe
 * Schaltfläche mit Beschriftung und Titel „New Container“; beides ist deshalb überschreibbar.
 *
 * Sie ist zugleich die wichtigste Aktion jeder Ansicht, in der sie vorkommt, und trägt
 * deshalb als einzige den Primärstil (REQ-21 §3). Die Rechnungszuordnungen zeigen sie nicht
 * und bleiben damit ohne Primärknopf.
 */

import type { ReactNode } from 'react';

import { Button } from '@/components/ui';

export interface NewButtonProps {
  title?: string;
  children?: ReactNode;
  onClick(): void;
}

export function NewButton(props: NewButtonProps) {
  return (
    <Button
      title={props.title ?? 'Create a new entry'}
      iconClass="e-icons e-plus"
      className="button-c"
      primary
      onClick={() => {
        props.onClick();
      }}
    >
      {props.children ?? 'New'}
    </Button>
  );
}

export default NewButton;
